// ==============================现舱大厅 精品预定 API==============================
import { jsonPost } from '@/utils/request'

/**
 * @description  新增发布与修改接口
 *
 * @export
 * @param {*} params
 */
export function addShippingSpaceha(params) {
    return jsonPost({
        url: `wzspacehall/addShippingSpaceha`,
        params
    })

}

/**
 * @description  现舱大厅（实名认证）接口
 *
 * @export
 * @param {*} params
 */
export function certification(params) {
    return jsonPost({
        url: `wzspacehall/certification`,
        params
    })

}

/**
 * @description  网站现舱大厅 查看列表接口
 *
 * @export
 * @param {*} params
 */
export function wzgetSpacelook(params) {
    return jsonPost({
        url: `wzspacehall/wzgetSpacelook`,
        params
    })

}

/**
 * @description  现舱大厅 查看详情接口
 *
 * @export
 * @param {*} params
 */
export function wzqueryMpSpace(params) {
    return jsonPost({
        url: `wzspacehall/wzqueryMpSpace`,
        params
    })

}

/**
 * @description  网站现舱大厅列表3个筛选条件列表查询
 *
 * @export
 * @param {*} params
 */
export function wzspacescreenlist(params) {
    return jsonPost({
        url: `wzspacehall/wzspacescreenlist`,
        params
    })

}